/* Étoiles (blocks/stars.liquid), source « Automatique » : lit en LECTURE SEULE la note affichée par
   la section d'avis de la page et met les étoiles à jour. ES5, une seule fois (window.__etoilesAuto). */
(function () {
  /* Source « Automatique » : lit, en LECTURE SEULE, la note, le nombre et la répartition affichés
     par la section d'avis de la page (section d'avis du thème, widget d'une appli d'avis), puis met à jour les
     étoiles, le texte et la carte de résumé. Rien n'est écrit ailleurs ; sans données, la note
     rendue par le serveur (métachamps reviews.* ou valeurs saisies) reste affichée. */
  if (window.__etoilesAuto) return;
  window.__etoilesAuto = true;

  function entier(t) { var n = parseInt(String(t || '').replace(/[^\d]/g, ''), 10); return isNaN(n) ? 0 : n; }

  function lireWidget() {
    var c, tot, n, el, moy, i;
    /* 1. Section d'avis du thème : barre du haut, remplie par son propre script. */
    var barres = document.querySelectorAll('[id^="crOverallBar-"]');
    for (i = 0; i < barres.length; i++) {
      var b = barres[i];
      if (b.hidden) continue;
      c = [0, 0, 0, 0, 0, 0]; tot = 0;
      for (n = 1; n <= 5; n++) {
        el = b.querySelector('[data-cr-breakdown-count="' + n + '"]');
        c[n] = el ? entier(el.textContent) : 0;
        tot += c[n];
      }
      if (!tot) continue;
      el = b.querySelector('[data-cr-avg-score]');
      moy = el ? parseFloat(String(el.textContent).replace(',', '.')) : NaN;
      if (isNaN(moy) || moy <= 0) moy = (c[1] + 2 * c[2] + 3 * c[3] + 4 * c[4] + 5 * c[5]) / tot;
      return { note: moy, nombre: tot, rep: c };
    }
    /* 2. Widget d'une appli d'avis courante : histogramme (classes jdgm-*). */
    var lignes = document.querySelectorAll('.jdgm-histogram__row[data-rating]');
    if (lignes.length) {
      c = [0, 0, 0, 0, 0, 0]; tot = 0;
      for (i = 0; i < lignes.length; i++) {
        n = entier(lignes[i].getAttribute('data-rating'));
        if (n >= 1 && n <= 5) { c[n] = entier(lignes[i].getAttribute('data-frequency')); tot += c[n]; }
      }
      if (tot) {
        el = document.querySelector('.jdgm-rev-widg[data-average-rating]');
        moy = el ? parseFloat(el.getAttribute('data-average-rating')) : NaN;
        if (isNaN(moy) || moy <= 0) moy = (c[1] + 2 * c[2] + 3 * c[3] + 4 * c[4] + 5 * c[5]) / tot;
        return { note: moy, nombre: tot, rep: c };
      }
    }
    return null;
  }

  function formatNote(v, sep) {
    var d = Math.max(0, Math.round(v * 10));
    return Math.floor(d / 10) + sep + (d % 10);
  }
  function formatNombre(v, sep) {
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, sep === 'nbsp' ? ' ' : sep);
  }
  function arrondir(v, mode) {
    if (mode === 'demi_proche') return Math.round(v * 2) / 2;
    if (mode === 'exacte') return v;
    return Math.max(0, Math.ceil(v * 2 - 0.001)) / 2;
  }
  function chaque(racine, sel, fn) { Array.prototype.forEach.call(racine.querySelectorAll(sel), fn); }

  function redessiner(racine, note, txtNote, txtNombre) {
    var modele = racine.querySelector('template[data-etres-modele]');
    var src = modele && modele.content ? modele.content : modele;
    var e = src && src.querySelector('.etoiles__e');
    if (!e) return;
    var vide = e.querySelector('svg');
    var plein = e.querySelector('.etoiles__p svg');
    if (!vide || !plein) return;
    var hVide = vide.outerHTML, hPlein = plein.outerHTML;
    var mode = racine.getAttribute('data-arrondi');
    var mot = racine.getAttribute('data-mot-avis') || '';
    chaque(racine, '.etoiles', function (et) {
      if (et.closest('template') || et.closest('.repn')) return;
      var cases = et.querySelectorAll('.etoiles__e');
      if (!/etoiles--une/.test(et.className)) {
        var r = arrondir(note * cases.length / 5, mode);
        for (var i = 0; i < cases.length; i++) {
          var part = r - i;
          var pct = part >= 1 ? 100 : (part <= 0 ? 0 : Math.round(part * 100));
          cases[i].className = 'etoiles__e stars-block__star stars-block__star--' + (pct === 100 ? 'pleine' : (pct === 0 ? 'vide' : 'demi'));
          cases[i].innerHTML = pct === 100 ? hPlein : hVide + (pct > 0 ? '<span class="etoiles__p" style="width: ' + pct + '%;">' + hPlein + '</span>' : '');
        }
      }
      chaque(et, '.etoiles__note', function (n) { n.textContent = txtNote; });
      chaque(et, '.etoiles__nombre', function (n) { n.textContent = '(' + txtNombre + ' ' + mot + ')'; });
      var aria = et.getAttribute('aria-label');
      if (aria) et.setAttribute('aria-label', aria.replace(/\d+(?:[.,]\d+)?/, txtNote).replace(/\(([\d\s., ]+)/, '(' + txtNombre));
    });
  }

  function appliquer(racine, d) {
    var sepDec = racine.getAttribute('data-sep-dec') || ',';
    var sepMil = racine.getAttribute('data-sep-mil') || 'nbsp';
    var txtNote = formatNote(d.note, sepDec);
    var txtNombre = formatNombre(d.nombre, sepMil);
    var reco = Math.round((d.rep[5] + d.rep[4]) * 100 / d.nombre);
    chaque(racine, '[data-etres-v="note"]', function (n) { n.textContent = txtNote; });
    chaque(racine, '[data-etres-v="nombre"]', function (n) { n.textContent = txtNombre; });
    chaque(racine, '[data-etres-v="reco"]', function (n) { n.textContent = String(reco); });
    chaque(racine, '[data-etres-nombre], [data-etres-repartition], [data-etres-reco]', function (n) { n.hidden = false; });
    /* note en attente d'une vraie source (snippets/note-auto) : révélée seulement maintenant */
    if (racine.hasAttribute('data-etres-attente')) { racine.style.display = ''; racine.removeAttribute('data-etres-attente'); }
    redessiner(racine, d.note, txtNote, txtNombre);
    chaque(racine, '.repn__ligne', function (li, i) {
      var cran = 5 - i;
      if (cran < 1) return;
      var pct = Math.round(d.rep[cran] * 100 / d.nombre);
      li.style.setProperty('--repn-v', pct + '%');
      var p = li.querySelector('.repn__pct');
      if (p) p.textContent = p.textContent.replace(/\d+/, String(pct));
    });
    racine.setAttribute('data-etres-source', 'page');
  }

  var essais = 0, minuteur = null;
  function passe() {
    var d = lireWidget();
    if (!d) return false;
    chaque(document, '[data-etres-auto]', function (r) { appliquer(r, d); });
    return true;
  }
  function guetter() {
    clearInterval(minuteur);
    essais = 0;
    if (passe()) return;
    minuteur = setInterval(function () {
      essais++;
      if (passe() || essais > 60) clearInterval(minuteur);
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guetter);
  else guetter();
  document.addEventListener('shopify:section:load', guetter);
})();
